import MembershipListItemSkeleton from "./membership-list-item-skeleton";

export interface MembershipListSkeletonProps {
	count?: number;
	className?: string;
}

export default function MembershipListSkeleton({ count = 3, className = "" }: MembershipListSkeletonProps) {
	return (
		<div className={`divide-y divide-gray-200 ${className}`}>
			{Array.from({ length: count }).map((_, index) => (
				<MembershipListItemSkeleton key={index} />
			))}
		</div>
	);
}
